import { styled } from '@mui/system';
import { Button, Typography, DialogTitle, DialogContent } from '@mui/material';

export const RootButton = styled(Button)(() => ({
  display: 'flex',
  alignItems: 'center',
  paddingTop: 0,
  paddingBottom: 0
}));

export const DatesText = styled(Typography)(() => ({
  fontSize: '1.1rem',
  textAlign: 'left'
}));

export const DateIcon = styled('span')(({ theme }) => ({
  margin: theme.spacing(-0.25, 0, 0, 1.5),
  display: 'flex'
}));

export const DateIconInvalid = styled(DateIcon)(() => ({
  color: 'red'
}));

export const InvalidText = styled(Typography)(() => ({
  color: 'red'
}));

export const StyledDialogTitle = styled(DialogTitle)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  paddingBottom: theme.spacing(3)
}));
